export default __webpack_public_path__ + "static/media/coins.a395d1ad.svg";